import { Fragment } from 'react'
import Slider from 'react-slick'
import { createUseStyles } from 'react-jss'
import { merge } from 'lodash'
import Link from 'next/link'
// import { Animated } from 'react-animated-css';

const useStyles = createUseStyles({
    itemSlide: {
        position: 'relative',
        top: 350,
        right: 30,
        textAlign: 'right',
        left: 'auto',
        float: 'right',
        zIndex: 9,
        marginTop: -200,
        maxWidth: 500
    },
    slide: {
        '& img': {
            height: '100%',
            borderRadius: '10px'
        }
    }
})

function SimpleSlider(props) {
    const settings = merge(
        {},
        {
            dots: true,
            autoplay: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: true,
            easing: 'swing',
            items: []
        },
        props
    )

    const classes = useStyles()

    return (
        <div className="text-center p-3">
            <Slider {...settings}>
                {settings.items.map((i, idx) => (
                    <Fragment key={idx}>
                        {i.content && (
                            <Link href={i.content}>
                                <div key={idx} className={`${classes.slide} cursor-pointer`}>
                                    <img src={`/api/${i.metas.pic_path.value}`} className="w-full mx-auto" alt={i.name} />
                                </div>
                            </Link>
                        )}
                        {!i.content && (
                            <div key={idx} className={`${classes.slide}`}>
                                <img src={`/api/${i.metas.pic_path.value}`} className="w-full mx-auto" alt={i.name} />
                            </div>
                        )}
                    </Fragment>
                ))}
            </Slider>
        </div>
    )
}

export { SimpleSlider }
